import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'sonner'
import AdminLayout from '@/components/layout/AdminLayout'
import LoadingSpinner from '@/components/shared/LoadingSpinner'
import LoginPage from '@/pages/auth/LoginPage'
import ForgotPasswordPage from '@/pages/auth/ForgotPasswordPage'
import ResetPasswordPage from '@/pages/auth/ResetPasswordPage'
import DashboardPage from '@/pages/dashboard/DashboardPage'
import UsersPage from '@/pages/users/UsersPage'
import UserDetailPage from '@/pages/users/UserDetailPage'
import VendorsPage from '@/pages/vendors/VendorsPage'
import VendorDetailPage from '@/pages/vendors/VendorDetailPage'
import CategoriesPage from '@/pages/categories/CategoriesPage'
import ProductsPage from '@/pages/products/ProductsPage'
import ProductNewPage from '@/pages/products/ProductNewPage'
import ProductDetailsPage from '@/pages/products/ProductDetailsPage'
import OrdersPage from '@/pages/orders/OrdersPage'
import OrderDetailPage from '@/pages/orders/OrderDetailPage'
import ShippingPage from '@/pages/shipping/ShippingPage'
import PromotionsPage from '@/pages/promotions/PromotionsPage'
import ReviewsPage from '@/pages/reviews/ReviewsPage'
import NotificationsPage from '@/pages/notifications/NotificationsPage'
import AnalyticsPage from '@/pages/analytics/AnalyticsPage'
import PayoutsPage from '@/pages/payouts/PayoutsPage'
import ReturnsPage from '@/pages/returns/ReturnsPage'
import ShipmentsPage from '@/pages/shipments/ShipmentsPage'
// import ChatPage from '@/pages/chat/ChatPage' // CHAT_DISABLED
import PlansPage from '@/pages/plans/PlansPage'
import SettingsPage from '@/pages/settings/SettingsPage'
import LoyaltyPage from '@/pages/loyalty/LoyaltyPage'
import ActivityLogsPage from '@/pages/activity-logs/ActivityLogsPage'
import BrandsPage from '@/pages/brands/BrandsPage'
import EarlyRegistrationsPage from "@/pages/early-registrations/EarlyRegistrationsPage"
import BannersPage from '@/pages/banners/BannersPage'
import BlogPage from '@/pages/blog/BlogPage'
import { ROUTES } from '@/constants/routes'

const ProductsImportPage = lazy(() => import('@/pages/products/ProductsImportPage'))

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            fontFamily: 'Tajawal, sans-serif',
            direction: 'rtl',
            borderRadius: '12px',
          },
        }}
      />
      <Routes>
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route path={ROUTES.RESET_PASSWORD} element={<ResetPasswordPage />} />
        <Route element={<AdminLayout />}>
          <Route path={ROUTES.DASHBOARD}      element={<DashboardPage />} />
          <Route path={ROUTES.ANALYTICS}      element={<AnalyticsPage />} />
          <Route path={ROUTES.USERS}          element={<UsersPage />} />
          <Route path={ROUTES.USER_DETAIL}    element={<UserDetailPage />} />
          <Route path={ROUTES.VENDORS}        element={<VendorsPage />} />
          <Route path={ROUTES.VENDOR_DETAIL}  element={<VendorDetailPage />} />
          <Route path={ROUTES.CATEGORIES}     element={<CategoriesPage />} />
          <Route path={ROUTES.BRANDS}         element={<BrandsPage />} />
          <Route path={ROUTES.PRODUCTS}       element={<ProductsPage />} />
          <Route
            path={ROUTES.PRODUCTS_IMPORT}
            element={
              <Suspense fallback={<LoadingSpinner fullPage />}>
                <ProductsImportPage />
              </Suspense>
            }
          />
          <Route path={ROUTES.PRODUCT_NEW}    element={<ProductNewPage />} />
          <Route path={ROUTES.PRODUCT_DETAIL} element={<ProductDetailsPage />} />
          <Route path={ROUTES.ORDERS}         element={<OrdersPage />} />
          <Route path={ROUTES.ORDER_DETAIL}   element={<OrderDetailPage />} />
          <Route path={ROUTES.RETURNS}        element={<ReturnsPage />} />
          <Route path={ROUTES.SHIPPING}       element={<ShippingPage />} />
          <Route path={ROUTES.SHIPMENTS}      element={<ShipmentsPage />} />
          <Route path={ROUTES.PAYOUTS}        element={<PayoutsPage />} />
          <Route path={ROUTES.PROMOTIONS}     element={<PromotionsPage />} />
          <Route path={ROUTES.REVIEWS}        element={<ReviewsPage />} />
          {/* <Route path={ROUTES.CHAT}           element={<ChatPage />} /> */}{/* CHAT_DISABLED */}
          <Route path={ROUTES.NOTIFICATIONS}  element={<NotificationsPage />} />
          <Route path={ROUTES.PLANS}          element={<PlansPage />} />
          <Route path={ROUTES.SETTINGS}       element={<SettingsPage />} />
          <Route path={ROUTES.LOYALTY}        element={<LoyaltyPage />} />
          <Route path={ROUTES.ACTIVITY_LOGS}  element={<ActivityLogsPage />} />
          <Route path={ROUTES.EARLY_REGISTRATIONS} element={<EarlyRegistrationsPage />} />
          <Route path={ROUTES.BANNERS}        element={<BannersPage />} />
          <Route path={ROUTES.BLOG}           element={<BlogPage />} />
        </Route>
        <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
      </Routes>
    </BrowserRouter>
  )
}
